import { render, staticRenderFns } from "./AuditLogDetails.vue?vue&type=template&id=1e2b8f72&"
import script from "./AuditLogDetails.vue?vue&type=script&lang=js&"
export * from "./AuditLogDetails.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports